import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RootComponent} from './sofbox/root/root.component';
import { IndexComponent} from './landing-page/index/index.component';
import { ActivateComponent } from './landing-page/components/activate/activate.component';
import { PaymentComponent } from './landing-page/components/payment/payment.component';
import { ClaimComponent } from './landing-page/components/claim/claim.component';
import { CoBrandingComponent } from './landing-page/components/co-branding/co-branding.component';
import { SSOComponent } from './landing-page/components/sso/sso.component';
//import { PasswordStrengthComponent } from '../password-strength/password-strength.component';
const routes: Routes = [
  { path: '', component: RootComponent },
  {
    path: 'members',
    component: RootComponent,
    children:[
               {
                 path:'members/:clientid',
                 component:IndexComponent
               },
               {
                 path:'members/:clientid/payment',
                 component:PaymentComponent
               },
               {
                 path:'members/:clientid/activate/:memberid',
                 component:ActivateComponent
               },
               {
                 path: 'members/:clientid/claim',
                 component: ClaimComponent
               },
               {
                 path: 'members/:clientid/sso',
                 component: SSOComponent
               },
               {
                 path: 'co-branding',
                 component: CoBrandingComponent
               }
             ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
